t<template>
  <footer class="footer">
    <!-- <div class="footer__toggle">
      <button @click="toggleFooterDesc = !toggleFooterDesc">
        <v-icon v-if="!toggleFooterDesc">mdi-chevron-up</v-icon>
        <v-icon v-if="!!toggleFooterDesc">mdi-chevron-down</v-icon>
      </button>
    </div> -->
    <div class="footer__left"></div>
    <div class="footer__middle">
      <img :src="require('@/assets/img/footer_logos.png')" alt="Loga" />
    </div>
    <div class="footer__right">
      <div class="footer__temperature">
        <!-- <WeatherTrigger /> -->
      </div>
      <div class="footer__time">
        <Clock></Clock>
      </div>
    </div>
  </footer>
</template>

<script>

import { ref } from 'vue';
import Clock from '@/components/structural/Clock.vue';
// import WeatherTrigger from '@/components/structural/WeatherTrigger.vue';

export default {
  name: 'FooterBar',
  components: {
    Clock,
    // WeatherTrigger,
  },
  setup() {
    const toggleFooterDesc = ref(false);

    return {
      toggleFooterDesc,
    };
  },
};
</script>

<style scoped lang="scss">

.footer {
  display: flex;
  background-color: $main-bg-color;
  color: $main-font-color;
  width: 100%;
  position: relative;
  z-index: 1;
  box-shadow: 0px 3px 17px 0px rgba(0, 0, 0, 0.5);
  padding: 8px 16px;
  border: 2px solid $nav-layers-box-border;

  @include width-until($mobile) {
    // flex-direction: column;
  }

  &__desc {
    flex: 1;
    transition: all 0.3s ease-in-out;

    &--show {
      transition: all 0.3s ease-in-out;
      height: auto;
      max-height: 100%;
      overflow: auto;
      opacity: 1;
    }
  }

  &__right {
    padding: rem(4.8px) rem(18px);
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    @include width-until($mobile) {
      padding: 0;
      padding-left: 8px;
    }
  }

  &__middle {
    text-align: center;
    img {
      max-height: 46px;
    }
  }

  &__left, &__middle, &__right {
     @include width-from($mobile) {
      width: 33%;
     }
    
  }

  &__temperature {
    font-size: rem((30px));
  }

  &__toggle {
    position: absolute;
    background-color: $main-bg-color;
    color: $main-font-color;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    border-bottom: none;


  }

  &__disclaimer {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: rem(0.44px);
    color: #000000;
    text-align: center;
    padding: 5px 15px;
  }
}
</style>
